import React from 'react';
import ProtectedRoute from './public/ProtectedRoute';
import AppLayout from '../../layout/AppLayout';

export function withAppLayout(element) {
  return (
    <ProtectedRoute>
      <AppLayout>{element}</AppLayout>
    </ProtectedRoute>
  );
}

export function withAuthOnly(element) {
  return <ProtectedRoute>{element}</ProtectedRoute>;
}
